// Garante que tudo seja salvo como GFM ("- [ ]"/"- [x]"), mas aceita glifos (◯/✓) na leitura/toggle.

export function isTaskLine(line: string): boolean {
  return /^(\s*)(?:-|\*)\s\[( |x|X)\]\s.+$/.test(line) || /^(\s*)[◯✓]\s.+$/.test(line);
}

export function normalizeTaskLineToGFM(line: string): string {
  // glifos -> GFM
  const mGlyph = line.match(/^(\s*)([◯✓])\s(.*)$/);
  if (mGlyph) {
    const [, indent, mark, rest] = mGlyph;
    const checked = mark === '✓';
    return `${indent}- [${checked ? 'x' : ' '}] ${rest}`;
  }
  // já é GFM -> normaliza x maiúsculo/minúsculo
  const m = line.match(/^(\s*)(?:-|\*)\s\[( |x|X)\]\s(.*)$/);
  if (m) {
    const [, indent, mark, rest] = m;
    const checked = mark.toLowerCase() === 'x';
    return `${indent}- [${checked ? 'x' : ' '}] ${rest}`;
  }
  return line;
}

export function normalizeAllToGFM(text: string): string {
  return (text || '').split(/\r?\n/).map(l => isTaskLine(l) ? normalizeTaskLineToGFM(l) : l).join('\n');
}

export function toggleTaskAt(text: string, index: number): string {
  const lines = (text || '').split(/\r?\n/);
  if (index < 0 || index >= lines.length) return text;
  let line = lines[index];
  if (!isTaskLine(line)) return text;

  // garanta GFM primeiro
  line = normalizeTaskLineToGFM(line);

  const m = line.match(/^(\s*)(?:-|\*)\s\[( |x)\]\s(.*)$/i);
  if (!m) return text;

  const [, indent, mark, rest] = m;
  const checked = mark.toLowerCase() === 'x';
  const next = `${indent}- [${checked ? ' ' : 'x'}] ${rest}`;
  lines[index] = next;
  return lines.join('\n');
}

export function parseTaskLine(line: string): { indent: string; checked: boolean; text: string } | null {
  // aceita GFM e glifos; devolve estado normalizado
  const g = line.match(/^(\s*)(?:-|\*)\s\[( |x|X)\]\s(.*)$/);
  if (g) {
    const [, indent, mark, rest] = g;
    return { indent, checked: mark.toLowerCase() === 'x', text: rest };
  }
  const m = line.match(/^(\s*)([◯✓])\s(.*)$/);
  if (m) {
    const [, indent, mark, rest] = m;
    return { indent, checked: mark === '✓', text: rest };
  }
  return null;
}
